import { OpenAPI } from "pwapi/core/OpenAPI";

const configureRemoteAPI = () => {
  const { REACT_APP_FORCE_API_PROXY } = process.env;

  // Changes to this condition should also be applied to hooks/useWebSocket.ts
  if (REACT_APP_FORCE_API_PROXY === "true") {
    // Setting an empty string will make all API requests root-relative which will hit the API proxy.
    // This is used to bypass CORS when using a remote server from a local environment.
    OpenAPI.BASE = "";
  } else {
    // CORS is configured for dev, stage, and production environments to allow API requests directly from the frontend.
    OpenAPI.BASE = `${process.env.REACT_APP_BACKEND_PROTOCOL}://${process.env.REACT_APP_BACKEND_HOST}:${process.env.REACT_APP_BACKEND_PORT}`;
  }
};

export default configureRemoteAPI;
